import Vue from 'vue'

const LOGIN_TIMESTAMP = 'LOGIN_TIMESTAMP'

class LoginControl {
  logoutInterval = 0;

  run () {
    this.clearLoginTimestamp()
    const $userControl = Vue.prototype.$userControl

    if (!$userControl.jwtParsed) {
      return
    }

    this.logoutInterval = setInterval(() => {
      const isNeedLogout = this.checkIsNeedLogout()

      if (isNeedLogout) {
        $userControl.logout()
        this.destroy()
      }
    }, 60 * 1000)
  }

  checkIsNeedLogout () {
    const loginTimestampStr = localStorage.getItem(LOGIN_TIMESTAMP)

    if (!loginTimestampStr) {
      this.setLoginTimestamp()

      return false
    }

    const loginDay = new Date(+loginTimestampStr).getDay()
    const nowDay = new Date().getDay()
    const hours = new Date().getHours()
    const isNextDay = loginDay !== nowDay && hours > 1

    return isNextDay
  }

  destroy () {
    this.clearAutoLogoutListener()
    this.clearLoginTimestamp()
  }

  clearAutoLogoutListener () {
    clearInterval(this.logoutInterval)
  }

  setLoginTimestamp () {
    const timestampStr = new Date().getTime().toString()
    localStorage.setItem(LOGIN_TIMESTAMP, timestampStr)
  }

  clearLoginTimestamp () {
    localStorage.removeItem(LOGIN_TIMESTAMP)
  }
}

const loginControl = new LoginControl()

export default loginControl



// WEBPACK FOOTER //
// ./src/helpers/loginControl.js